import { api } from '@services';

import EquipmentStatus, {
  EquipmentStatusCategoryOptions,
} from '@models/EquipmentStatus.model';

interface ICreateStudioEquipmentStatus {
  id: string;
  name: string;
  description: string;
  category: EquipmentStatusCategoryOptions;
}

const createStudioEquipmentStatus = async ({
  id,
  name,
  description,
  category,
}: ICreateStudioEquipmentStatus): Promise<EquipmentStatus> => {
  const { data: equipmentStatus } = await api.post<EquipmentStatus>(
    `/studios/${id}/equipmentStatus`,
    {
      name,
      description,
      category,
    },
  );

  return EquipmentStatus.fromApiModel(equipmentStatus);
};

export { createStudioEquipmentStatus };
